// Duplicated from backend/domain/categories.js and backend/domain/reminders.js
// on purpose (§4.1); tests/frontend.test.mjs keeps the two equal.

export const CATEGORIES = [
  { id: 'work', color: '#2563eb' },
  { id: 'meeting', color: '#7c3aed' },
  { id: 'customer', color: '#059669' },
  { id: 'supplier', color: '#d97706' },
  { id: 'visit', color: '#0891b2' },
  { id: 'personal', color: '#db2777' },
  { id: 'travel', color: '#64748b' },
  { id: 'important', color: '#dc2626' },
]

export const EVENT_TYPES = ['event', 'meeting', 'call', 'visit', 'reminder', 'appointment']

export const REMINDER_PRESETS = [0, 5, 10, 15, 30, 60, 1440]

export const MAX_REMINDER_MINUTES = 10080

export const VIEWS = ['day', 'workweek', 'week', 'month']

/** The colour of an event: its category, else its calendar. */
export function colorOf(event, fallback = '#2563eb') {
  const category = CATEGORIES.find(entry => entry.id === event?.category)
  return category?.color ?? event?.calendarColor ?? event?.color ?? fallback
}
